import { useEffect, useState } from 'react';

export const invoiceTariffLabel = (offer, descriptions = {}) => {
    const id = String(offer?.tarifa_id);
    return (Object.prototype.hasOwnProperty.call(descriptions, id) && descriptions[id]) || offer?.nombre || offer?.tarifa_id;
};

export default function useInvoiceTariffDescriptions(api, offers) {
    const ids = JSON.stringify([...new Set((offers || []).map(offer => String(offer.tarifa_id)))]);
    const [retry, setRetry] = useState(0);
    const [state, setState] = useState({ key: '', descriptions: {}, loading: Boolean(api), error: '' });
    useEffect(() => {
        if (!api) return undefined;
        const controller = new AbortController();
        setState({ key: ids, descriptions: {}, loading: true, error: '' });
        const values = JSON.parse(ids), batches = [];
        for (let offset = 0; offset < values.length; offset += 1000) batches.push(values.slice(offset, offset + 1000));
        Promise.all(batches.map(tariff_ids => api('/tariff-descriptions/resolve', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ tariff_ids }), signal: controller.signal,
        }))).then(results => {
            if (!controller.signal.aborted) setState({ key: ids, descriptions: Object.assign({}, ...results.map(result => result.descriptions)), loading: false, error: '' });
        }).catch(error => {
            if (!controller.signal.aborted) setState({ key: ids, descriptions: {}, loading: false, error: error.message || 'No se han podido recuperar los nombres de las tarifas.' });
        });
        return () => controller.abort();
    }, [api, ids, retry]);
    return { ...state, loading: Boolean(api) && (state.loading || state.key !== ids), reload: () => setRetry(value => value + 1) };
}
